<footer
    #footer
    class="tw-bg-[#0A0A75] tw-bottom-0 tw-px-[9vw] md:tw-px-[6vw] tw-py-[50px] tw-text-white tw-w-screen"
>
    <app-footer-subscribe></app-footer-subscribe>

    <!-- New Footer -->
    <!-- <app-new-footer 
        [selectedLanguage]="selectedLanguage" 
        [gtmTags]="gtmTags">
    </app-new-footer> -->
    <app-new-footer-v2
        [selectedLanguage]="selectedLanguage" 
        [gtmTags]="gtmTags">
    </app-new-footer-v2>
    <div
        class="tw-flex md:tw-hidden tw-justify-between tw-items-center tw-pb-[0rem] tw-mt-[100px] !tw-whitespace-nowrap"
    >
        <button
            class="tw-flex tw-py-4 tw-px-6 tw-justify-center tw-items-center tw-gap-3 tw-rounded-[6rem] tw-bg-[#FFF] tw-bg-opacity-10 tw-text-white tw-font-semibold"
            (click)="scroll()"
        >
            <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.27947 2.4481L6.27947 10.9871L5.30545 10.9871L5.30545 2.4481L1.27947 6.47407L0.597656 5.79226L5.79246 0.59745L10.9873 5.79225L10.3054 6.47407L6.27947 2.4481Z"
                    fill="white"
                    stroke="white"
                    stroke-width="0.5"
                />
            </svg>
            {{ "FOOTER.BACK_TO_TOP" | translate }}
        </button>
    </div>
</footer>
